<template>
  <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
      <v-card max-height="600px">
			<v-toolbar flat color="primary white--text"><h1>Aula</h1></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col cols="12" class="col-sm-2">
                        <v-text-field dense label="Código" readonly v-model="aula.id" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" class="col-sm-10">
                        <v-text-field dense label="Titulo" v-model="aula.nome" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field dense label="Url Video" v-model="aula.url_video" outlined></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" v-if="aula.tipo_aula == 'A'">
                        <v-text-field dense label="Arquivo" v-model="arquivoAudio.name" readonly outlined></v-text-field>
                        <input type="file" ref="audioFile" @change="onFileAudioSelected" style="display:none" />
                        <v-btn small class="mr-4" color="primary my-4" @click="launchFilePickerAudio()">Selecionar arquivo</v-btn>
                        <v-btn small v-if="salvarAudio" color="primary my-4" @click="uploadAudio">Enviar Arquivo</v-btn>
                    </v-col>
                    <v-col cols="12" v-if="aula.tipo_aula == 'T'">
                        <v-text-field dense label="Arquivo" v-model="arquivoTexto.name" readonly outlined></v-text-field>
                        <input type="file" ref="textoFile" @change="onFileTextoSelected" style="display:none" />
                        <v-btn small class="mr-4" color="primary my-4" @click="launchFilePickerTexto()">Selecionar arquivo</v-btn>
                        <v-btn small v-if="salvarTexto" color="primary my-4" @click="uploadTexto">Enviar Arquivo</v-btn>
                    </v-col> -->
                </v-row>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
  </v-dialog>   
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showSuccess, showError } from "@/config/global"

export default {
    name: 'Aula',
    props:['mostrar', 'idModulo', 'aulaEdicao'],
    data(){
        return{
            aula:{
                id: 0
            },
            salvarAudio: false,
            arquivoAudio: {},
            salvarTexto: false,
            arquivoTexto: {},
        }
    },
    methods:{
        fechar(){
            this.aula = {id: 0}
            this.$emit('fecharAula')
        },

        launchFilePickerAudio(){
            this.$refs.audioFile.click()
        },
        launchFilePickerTexto(){
            this.$refs.textoFile.click()
        },
        onFileAudioSelected(ev){
            this.arquivoAudio = ev.target.files[0]
            
            if(!this.arquivoAudio.type.match('audio.*')){
                showError("Arquivo selecionado nao corresponde a um audio")
                this.salvarAudio = false
            }else{
                this.salvarAudio = true
            }
        },
        uploadAudio(){
            let idAula = this.aula.id
            let nomeArquivo = this.arquivoAudio.name

            const url = `${baseApiUrl}/Cursos/uploadAudio.php`
            let reader = new FileReader()
            reader.onloadend = function(){
                let img64 = reader.result
                let obj = {
                    arquivo: img64,
                    aula: idAula,
                    nomeArquivo: nomeArquivo
                }

                axios.post(url, obj).then(res => { 
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                    }else{
                        showError(res.data.mensagem)
                    }
                })
            }
            reader.readAsDataURL(this.arquivoAudio)
        },

        onFileTextoSelected(ev){
            this.arquivoTexto = ev.target.files[0]
            
            if(!this.arquivoTexto.type.match('application/pdf')){
                showError("Arquivo selecionado nao corresponde a um pdf")
                this.salvarTexto = false
            }else{
                this.salvarTexto = true
            }
        },

        uploadTexto(){
            let idAula = this.aula.id
            let nomeArquivo = this.arquivoTexto.name

            const url = `${baseApiUrl}/Cursos/uploadTexto.php`
            let reader = new FileReader()
            reader.onloadend = function(){
                let img64 = reader.result
                let obj = {
                    arquivo: img64,
                    aula: idAula,
                    nomeArquivo: nomeArquivo
                }

                axios.post(url, obj).then(res => {
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                    }else{
                        showError(res.data.mensagem)
                    }
                })
            }
            reader.readAsDataURL(this.arquivoTexto)
        },


        salvar(){
            if(this.aula.id == 0){
                const url = `${baseApiUrl}/Cursos/insertAula.php`
                this.aula.id_modulo = this.idModulo

                axios.post(url, this.aula)
                .then(res => {
                    if(res.data.codigo == '01'){ 
                        showSuccess(res.data.mensagem)
                        this.aula.id = res.data.id
                        this.$emit('aulaCadastrado', this.aula)
                        this.fechar()
                    }else{
                        showError(res.data.mensagem)
                    }
                })
            }else{
                const url = `${baseApiUrl}/Cursos/updateAula.php`
                this.aula.id_aula = this.idAula

                axios.post(url, this.aula)
                .then(res => {
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                        this.$emit('aulaAtualizado', this.aula)
                        this.fechar()
                    }else{
                        showError(res.data.mensagem)
                    }
                })
            }
        }
    },
    watch:{
        mostrar(v){
            if(v){
                if(this.aulaEdicao.id){
                    this.aula = this.aulaEdicao
                }
                
            }
        }
    },
}
</script>

<style scoped>

</style>